import { useState } from 'react';
import { matchesSearch } from './search';

export interface SearchOption {
  value: string;
  label: string;
  /** نص إضافى يُبحث فيه ولا يظهر (تليفون، كود منظومة). */
  keywords?: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  options: readonly SearchOption[];
  /** نص الخيار الفاضى، مثل «— اختر عميلاً —». */
  emptyLabel: string;
  placeholder?: string;
  disabled?: boolean;
}

/** أقل من كده القائمة قصيرة، وخانة البحث تزحم النموذج بلا فايدة. */
const SEARCH_FROM = 8;

/**
 * قائمة اختيار بخانة بحث فوقها: الكتابة تضيّق الخيارات بنفس مطابقة القوائم
 * (`matchesSearch`)، وEnter يختار أول نتيجة. الخيار المختار يفضل ظاهر حتى لو البحث
 * ما يطابقوش، فالنموذج ما يفقدش قيمته من تحت المستخدم.
 */
export default function SearchSelect({
  value,
  onChange,
  options,
  emptyLabel,
  placeholder = 'دوّر…',
  disabled,
}: Props) {
  const [query, setQuery] = useState('');
  const filtered = options.filter(
    (option) => option.value === value || matchesSearch(query, [option.label, option.keywords]),
  );
  const firstMatch = filtered.find((option) => option.value !== value) ?? filtered[0];

  return (
    <span className="search-select">
      {options.length >= SEARCH_FROM && (
        <input
          type="search"
          value={query}
          disabled={disabled}
          placeholder={placeholder}
          aria-label="بحث فى الخيارات"
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              // Enter داخل نموذج يرسله — هنا معناه «اختار أول نتيجة» بس
              event.preventDefault();
              if (query && firstMatch) {
                onChange(firstMatch.value);
                setQuery('');
              }
            }
          }}
        />
      )}
      <select value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
        <option value="">{emptyLabel}</option>
        {filtered.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {query && filtered.length === 0 && <span className="label">مفيش نتايج</span>}
    </span>
  );
}
